// wap 版 tabbar
const trendTabbarMapping = {
  hk6: [
    {
      value: 'tab_zongHe',
      label: '综合',
      isActive: false,
      list: [
        {
          label: '开奖号码',
          value: 'KaiJiangHaoMaHk',
          isActive: true
        },
        {
          label: '今年双面统计',
          value: 'JinRihNianShuangMianTongJi',
          isActive: false
        },
        {
          label: '今年长龙统计',
          value: 'JinRihNianChangLongTongJi',
          isActive: false
        },
        {
          label: '热门号码统计',
          value: 'ReMenHaoMaTongJi',
          isActive: false
        },
        {
          label: '遗漏号码统计',
          value: 'YiLouHaoMaTongJi',
          isActive: false
        },
        {
          label: '热门生肖统计',
          value: 'ReMenShengXiaoTongJi',
          isActive: false
        },
        {
          label: '遗漏生肖统计',
          value: 'YiLouShengXiaoTongJi',
          isActive: false
        }

      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      isActive: false,
      list: [
        {
          label: '单双路珠',
          value: 'DanShuangLuJhu',
          isActive: true
        },
        {
          label: '大小路珠',
          value: 'DaXiaoLuJhu',
          isActive: false
        },
        {
          label: '波色路珠',
          value: 'BoSeLuJhu',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      isActive: false,
      list: [
        {
          label: '正码走势',
          value: 'ZhengMaZouShi',
          isActive: true
        },
        {
          label: '特码走势',
          value: 'TeMaZouShi',
          isActive: false
        },
        {
          label: '生肖走势',
          value: 'ShengXiaoZouShi',
          isActive: false
        },
        {
          label: '家禽野兽走势',
          value: 'JiaQinYeShouZouShi',
          isActive: false
        },
        {
          label: '男女生肖走势',
          value: 'NanNuShengXiaoZouShi',
          isActive: false
        },
        {
          label: '天地生肖走势',
          value: 'TianDiShengXiaoZouShi',
          isActive: false
        },

        {
          label: '四季生肖走势',
          value: 'SiJiShengXiaoZouShi',
          isActive: false
        },
        {
          label: '琴棋书画走势          ',
          value: 'QinQiShuHuaZouShi',
          isActive: false
        },
        {
          label: '三色生肖走势',
          value: 'SanSeShengXiaoZouShi',
          isActive: false
        }
      ]
    }
  ],
  pk10: [
    {
      value: 'tab_zongHe',
      label: '综合',
      isActive: false,
      list: [
        {
          label: '开奖号码',
          value: 'KaiJiangHaoMa',
          isActive: false
        },
        {
          label: '今日双面统计',
          value: 'JinRiShuangMianTongJi',
          isActive: false
        },
        {
          label: '今日长龙统计',
          value: 'JinRiChangLongTongJi',
          isActive: false
        },
        {
          label: '号码助手',
          value: 'HaoMaJhuShou',
          isActive: false
        },
        {
          label: '号码规律统计',
          value: 'HaoMaGuiLuTongJi',
          isActive: false
        },
        {
          label: '今日号码统计',
          value: 'JinRiHaoMaTongJi',
          isActive: false
        },
        {
          label: '冷热分析',
          value: 'LengReFenXi',
          isActive: false
        },
        {
          label: '单双大小历史',
          value: 'DanShuangDaxiaoLiShi',
          isActive: false
        },
        {
          label: '龙虎统计',
          value: 'LongHuTongJi',
          isActive: false
        },
        {
          label: '冠亚和两面统计',
          value: 'GuanYaHeLiangMianTongJi',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      isActive: false,
      list: [
        {
          label: '路珠分析',
          value: 'LuJhuFenSi',
          isActive: false
        },
        {
          label: '龙虎路珠',
          value: 'LongHuLuJhu',
          isActive: false
        },
        {
          label: '单双大小路珠',
          value: 'DanShuangDaXiaoLuJhu',
          isActive: false
        },
        {
          label: '冠亚和路珠',
          value: 'GuanYaHeLuJhu',
          isActive: false
        },
        {
          label: '号码前后路珠',
          value: 'HaoMaChianHouLuJhu',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      isActive: false,
      list: [
        {
          label: '定位走势',
          value: 'DingWeiZouShih',
          isActive: false
        },
        {
          label: '冠亚和走势',
          value: 'GuanYaHeZouShih',
          isActive: false
        }
      ]
    }
  ],
  k3: [
    {
      value: 'tab_zongHe',
      label: '综合',
      isActive: false,
      list: [
        {
          label: '开奖号码',
          value: 'KaiJiangHaoMa',
          isActive: false
        },
        {
          label: '历史号码统计',
          value: 'LiShiHaoMaTongJi',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      isActive: false,
      list: [
        {
          label: '号码路珠',
          value: 'HaoMaLuJhu',
          isActive: false
        },
        {
          label: '总和路珠',
          value: 'ZongHeLuJhu',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      isActive: false,
      list: [
        {
          label: '定位走势',
          value: 'DingWeiZouShih',
          isActive: false
        },
        {
          label: '和值走势',
          value: 'HeJhihZouShih',
          isActive: false
        },
        {
          label: '大小走势',
          value: 'DaXiaoZouShih',
          isActive: false
        },
        {
          label: '奇偶走势',
          value: 'JiOuZouShih',
          isActive: false
        },
        {
          label: '号码分布',
          value: 'HaoMaFenBu',
          isActive: false
        }
      ]
    }
  ],
  '11x5': [
    {
      value: 'tab_zongHe',
      label: '综合',
      isActive: false,
      list: [
        {
          label: '开奖号码',
          value: 'KaiJiangHaoMa',
          isActive: false
        },
        {
          label: '今日双面统计',
          value: 'JinRiShuangMianTongJi',
          isActive: false
        },
        {
          label: '今日长龙统计',
          value: 'JinRiChangLongTongJi',
          isActive: false
        },
        {
          label: '号码助手',
          value: 'HaoMaJhuShou',
          isActive: false
        },
        {
          label: '今日号码统计',
          value: 'JinRiHaoMaTongJi',
          isActive: false
        },
        {
          label: '冷热分析',
          value: 'LengReFenXi',
          isActive: false
        },
        {
          label: '单双大小历史',
          value: 'DanShuangDaxiaoLiShi',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      isActive: false,
      list: [
        {
          label: '总和路珠',
          value: 'ZongHeLuJhu',
          isActive: false
        },
        {
          label: '单双大小路珠',
          value: 'DanShuangDaXiaoLuJhu',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      isActive: false,
      list: [
        {
          label: '定位走势',
          value: 'DingWeiZouShih',
          isActive: false
        },
        {
          label: '和值走势',
          value: 'HeJhihZouShih',
          isActive: false
        },
        {
          label: '龙虎走势',
          value: 'LongHuZouShih',
          isActive: false
        }
      ]
    }
  ],
  ssc: [
    {
      value: 'tab_zongHe',
      label: '综合',
      isActive: false,
      list: [
        {
          label: '开奖号码',
          value: 'KaiJiangHaoMa',
          isActive: false
        },
        {
          label: '今日双面统计',
          value: 'JinRiShuangMianTongJi',
          isActive: false
        },
        {
          label: '今日长龙统计',
          value: 'JinRiChangLongTongJi',
          isActive: false
        },
        {
          label: '号码助手',
          value: 'HaoMaJhuShou',
          isActive: false
        },
        {
          label: '今日号码统计',
          value: 'JinRiHaoMaTongJi',
          isActive: false
        },
        {
          label: '冷热分析',
          value: 'LengReFenXi',
          isActive: false
        },
        {
          label: '单双大小历史',
          value: 'DanShuangDaxiaoLiShi',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      isActive: false,
      list: [
        {
          label: '路珠分析',
          value: 'LuJhuFenSi',
          isActive: false
        },
        {
          label: '号码路珠',
          value: 'HaoMaLuJhu',
          isActive: false
        },
        {
          label: '单双大小路珠',
          value: 'DanShuangDaXiaoLuJhu',
          isActive: false
        },
        {
          label: '总和路珠',
          value: 'ZongHeLuJhu',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      isActive: false,
      list: [
        {
          label: '定位走势',
          value: 'DingWeiZouShih',
          isActive: false
        },
        {
          label: '龙虎走势',
          value: 'LongHuZouShih',
          isActive: false
        },
        {
          label: '形态走势',
          value: 'XingTaiZouShih',
          isActive: false
        }
      ]
    }
  ],
  xy28: [
    {
      value: 'tab_zongHe',
      label: '综合',
      isActive: false,
      list: [
        {
          label: '开奖号码',
          value: 'KaiJiangHaoMa',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      isActive: false,
      list: [
        {
          label: '总和路珠',
          value: 'ZongHeLuJhu',
          isActive: false
        },
        {
          label: '波色路珠',
          value: 'PoSeLuJhu',
          isActive: false
        }
      ]
    }
  ],
  kl8: [
    {
      value: 'tab_zongHe',
      label: '综合',
      isActive: false,
      list: [
        {
          label: '开奖号码',
          value: 'KaiJiangHaoMa',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      isActive: false,
      list: [
        {
          label: '路珠分析',
          value: 'LuJhuFenSi',
          isActive: false
        }
      ]
    }
  ],
  kl10: [
    {
      value: 'tab_zongHe',
      label: '综合',
      isActive: false,
      list: [
        {
          label: '开奖号码',
          value: 'KaiJiangHaoMa',
          isActive: false
        },
        {
          label: '今日双面统计',
          value: 'JinRiShuangMianTongJi',
          isActive: false
        },
        {
          label: '今日长龙统计',
          value: 'JinRiChangLongTongJi',
          isActive: false
        },
        {
          label: '号码助手',
          value: 'HaoMaJhuShou',
          isActive: false
        },
        {
          label: '今日号码统计',
          value: 'JinRiHaoMaTongJi',
          isActive: false
        },
        {
          label: '单双大小历史',
          value: 'DanShuangDaxiaoLiShi',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      isActive: false,
      list: [
        {
          label: '路珠分析',
          value: 'LuJhuFenSi',
          isActive: false
        },
        {
          label: '单双大小路珠',
          value: 'DanShuangDaXiaoLuJhu',
          isActive: false
        },
        {
          label: '龙虎路珠',
          value: 'LongHuLuJhu',
          isActive: false
        },
        {
          label: '尾数大小路珠',
          value: 'WeiShuDaXiaoLuJhu',
          isActive: false
        },
        {
          label: '合数单双路珠',
          value: 'HeShuDanShuangLuJhu',
          isActive: false
        },
        {
          label: '中发白路珠',
          value: 'JhongFaBaiLuJhu',
          isActive: false
        },
        {
          label: '东南西北路珠',
          value: 'DongNanSiBeiLuJhu',
          isActive: false
        },
        {
          label: '总和路珠',
          value: 'ZongHeLuJhu',
          isActive: false
        },
        {
          label: '号码路珠',
          value: 'HaoMaLuJhu',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      isActive: false,
      list: [
        {
          label: '号码分布',
          value: 'HaoMaFenBu',
          isActive: false
        },
        {
          label: '大小走势',
          value: 'DaXiaoZouShih',
          isActive: false
        },
        {
          label: '奇偶走势',
          value: 'JiOuZouShih',
          isActive: false
        }
      ]
    }
  ],
  others: [
    {
      value: 'tab_zongHe',
      label: '综合',
      isActive: false,
      list: [
        {
          label: '开奖号码',
          value: 'KaiJiangHaoMa',
          isActive: false
        }
      ]
    }
  ]
}

// web 版 tabbar
const webTrendTabbarMapping = {
  hk6: [
    {
      value: 'tab_zongHe',
      label: '综合',
      isActive: false,
      list: [
        {
          label: '开奖号码',
          value: 'KaiJiangHaoMa',
          isActive: true
        },
        {
          label: '热门号码统计',
          value: 'ReMenHaoMaTongJi',
          isActive: false
        },
        {
          label: '遗漏号码统计',
          value: 'YiLouHaoMaTongJi',
          isActive: false
        },
        {
          label: '热门生肖统计',
          value: 'ReMenShengXiaoTongJi',
          isActive: false
        },
        {
          label: '遗漏生肖统计',
          value: 'YiLouShengXiaoTongJi',
          isActive: false
        }

      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      isActive: false,
      list: [
        {
          label: '单双路珠',
          value: 'DanShuangLuJhu',
          isActive: true
        },
        {
          label: '大小路珠',
          value: 'DaXiaoLuJhu',
          isActive: false
        },
        {
          label: '波色路珠',
          value: 'BoSeLuJhu',
          isActive: false
        },
        {
          label: '总和单双路珠',
          value: 'ZongHeDanShuangLuZhu',
          isActive: false
        },
        {
          label: '总和大小路珠',
          value: 'ZongHeDaXiaoLuZhu',
          isActive: false
        },
        {
          label: '尾数大小路珠',
          value: 'WeiShuDaXiaoLuZhu',
          isActive: false
        },
        {
          label: '合数单双路珠',
          value: 'HeShuDanShuangLuZhu',
          isActive: false
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      isActive: false,
      list: [
        {
          label: '正码走势',
          value: 'ZhengMaZouShi',
          isActive: true
        },
        {
          label: '特码走势',
          value: 'TeMaZouShi',
          isActive: false
        },
        {
          label: '生肖走势',
          value: 'ShengXiaoZouShi',
          isActive: false
        },
        {
          label: '家禽野兽走势',
          value: 'JiaQinYeShouZouShi',
          isActive: false
        },
        {
          label: '男女生肖走势',
          value: 'NanNuShengXiaoZouShi',
          isActive: false
        },
        {
          label: '天地生肖走势',
          value: 'TianDiShengXiaoZouShi',
          isActive: false
        },

        {
          label: '四季生肖走势',
          value: 'SiJiShengXiaoZouShi',
          isActive: false
        },
        {
          label: '琴棋书画走势          ',
          value: 'QinQiShuHuaZouShi',
          isActive: false
        },
        {
          label: '三色生肖走势',
          value: 'SanSeShengXiaoZouShi',
          isActive: false
        }
      ]
    }
  ],
  pk10: [
    {
      value: 'tab_zongHe',
      label: '综合',
      list: [
        {
          label: '即时开奖',
          value: 'JiShihKaiJiang',
          subList: [
            {
              label: '今日双面统计',
              value: 'JinRiShuangMianTongJi'

            },
            {
              label: '今日长龙统计',
              value: 'JinRiChangLongTongJi'
            },
            {
              label: '号码助手',
              value: 'HaoMaJhuShou'
            },
            {
              label: '历史开奖',
              value: 'LiShihKaiJiang'
            }
          ],
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JiShihKaiJiang`
          }
        },
        {
          label: '号码规律统计',
          value: 'HaoMaGuiLuTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HaoMaGuiLuTongJi`
          }
        },
        {
          label: '今日号码统计',
          value: 'JinRiHaoMaTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JinRiHaoMaTongJi`
          }
        },
        {
          label: '冷热分析',
          value: 'LengReFenXi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LengReFenXi`
          }
        },
        {
          label: '每日长龙统计',
          value: 'MeiRihChangLongTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=MeiRihChangLongTongJi`
          }
        },
        {
          label: '两面统计',
          value: 'LiangMianTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LiangMianTongJi`
          }
        },
        {
          label: '单双大小历史',
          value: 'DanShuangDaxiaoLiShi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DanShuangDaxiaoLiShi`
          }
        },
        {
          label: '龙虎统计',
          value: 'LongHuTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LongHuTongJi`
          }
        },
        {
          label: '冠亚和两面统计',
          value: 'GuanYaHeLiangMianTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=GuanYaHeLiangMianTongJi`
          }
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      list: [
        {
          label: '路珠分析',
          value: 'LuJhuFenSi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LuJhuFenSi`
          }
        },
        {
          label: '龙虎路珠',
          value: 'LongHuLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LongHuLuJhu`
          }
        },
        {
          label: '单双大小路珠',
          value: 'DanShuangDaXiaoLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DanShuangDaXiaoLuJhu`
          }
        },
        {
          label: '冠亚和路珠',
          value: 'GuanYaHeLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=GuanYaHeLuJhu`
          }
        },
        {
          label: '号码前后路珠',
          value: 'HaoMaChianHouLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HaoMaChianHouLuJhu`
          }
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      list: [
        {
          label: '定位走势',
          value: 'DingWeiZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DingWeiZouShih`
          }
        },
        {
          label: '基本走势',
          value: 'JiBenZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JiBenZouShih`
          }
        },
        {
          label: '冠亚和走势',
          value: 'GuanYaHeZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=GuanYaHeZouShih`
          }
        },
        {
          label: '两面横版走势',
          value: 'LiangMianHengBanZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LiangMianHengBanZouShih`
          }
        }
      ]
    },
    {
      value: 'tab_yutse',
      label: '预测',
      list: [
        {
          label: '两面推荐',
          value: 'LiangMianTueiJian',
          link(lotteryCode) {
            return `/lmtj/${lotteryCode}`
          }
        },
        {
          label: '专家推荐',
          value: 'JhuanJiaTueiJian',
          link(lotteryCode) {
            return `/expert/${lotteryCode}`
          }
        },
        {
          label: '购彩计划',
          value: 'GouTsaiJiHua',
          link(lotteryCode) {
            return `/buyplan/${lotteryCode}`
          }
        },
        {
          label: '杀号计划',
          value: 'ShaHaoJiHua',
          link(lotteryCode) {
            return `/shjh/${lotteryCode}`
          }
        }
      ]
    }
  ],
  k3: [
    {
      value: 'tab_zongHe',
      label: '综合',
      list: [
        {
          label: '即时开奖',
          value: 'JiShihKaiJiang',
          subList: [
            {
              label: '历史开奖',
              value: 'LiShihKaiJiang'
            }
          ],
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JiShihKaiJiang`
          }
        },
        {
          label: '历史号码统计',
          value: 'LiShiHaoMaTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LiShiHaoMaTongJi`
          }
        },
        {
          label: '每日长龙统计',
          value: 'MeiRihChangLongTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=MeiRihChangLongTongJi`
          }
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      list: [
        {
          label: '号码路珠',
          value: 'HaoMaLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HaoMaLuJhu`
          }
        },
        {
          label: '总和路珠',
          value: 'ZongHeLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=ZongHeLuJhu`
          }
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      list: [
        {
          label: '定位走势',
          value: 'DingWeiZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DingWeiZouShih`
          }
        },
        {
          label: '和值走势',
          value: 'HeJhihZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HeJhihZouShih`
          }
        },
        {
          label: '大小走势',
          value: 'DaXiaoZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DaXiaoZouShih`
          }
        },
        {
          label: '奇偶走势',
          value: 'JiOuZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JiOuZouShih`
          }
        },
        {
          label: '号码分布',
          value: 'HaoMaFenBu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HaoMaFenBu`
          }
        },
        {
          label: '和值横版走势',
          value: 'HeJhihHengBanZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HeJhihHengBanZouShih`
          }
        }
      ]
    },
    {
      value: 'tab_yutse',
      label: '预测',
      list: [
        {
          label: '购彩计划',
          value: 'GouTsaiJiHua',
          link(lotteryCode) {
            return `/buyplan/${lotteryCode}`
          }
        },
        {
          label: '杀号计划',
          value: 'ShaHaoJiHua',
          link(lotteryCode) {
            return `/shjh/${lotteryCode}`
          }
        }
      ]
    }
  ],
  '11x5': [
    {
      value: 'tab_zongHe',
      label: '综合',
      list: [
        {
          label: '即时开奖',
          value: 'JiShihKaiJiang',
          subList: [
            {
              label: '今日双面/号码统计',
              value: 'JinRiShuangMianHaoMaTongJi'
            },
            {
              label: '今日长龙统计',
              value: 'JinRiChangLongTongJi'
            },
            {
              label: '号码助手',
              value: 'HaoMaJhuShou'

            },
            {
              label: '历史开奖',
              value: 'LiShihKaiJiang'

            }
          ],
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JiShihKaiJiang`
          }
        },
        {
          label: '今日号码统计',
          value: 'JinRiHaoMaTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JinRiHaoMaTongJi`
          }
        },
        {
          label: '冷热分析',
          value: 'LengReFenXi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LengReFenXi`
          }
        },
        {
          label: '每日长龙统计',
          value: 'MeiRihChangLongTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=MeiRihChangLongTongJi`
          }
        },
        {
          label: '单双大小历史',
          value: 'DanShuangDaxiaoLiShi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DanShuangDaxiaoLiShi`
          }
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      list: [
        {
          label: '总和路珠',
          value: 'ZongHeLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=ZongHeLuJhu`
          }
        },
        {
          label: '单双大小路珠',
          value: 'DanShuangDaXiaoLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DanShuangDaXiaoLuJhu`
          }
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      list: [
        {
          label: '定位走势',
          value: 'DingWeiZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DingWeiZouShih`
          }
        },
        {
          label: '号码分布',
          value: 'HaoMaFenBu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HaoMaFenBu`
          }
        },
        {
          label: '和值走势',
          value: 'HeJhihZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HeJhihZouShih`
          }
        },
        {
          label: '龙虎走势',
          value: 'LongHuZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LongHuZouShih`
          }
        },
        {
          label: '定位横版走势',
          value: 'DingWeiHengBanZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DingWeiHengBanZouShih`
          }
        }
      ]
    },
    {
      value: 'tab_yutse',
      label: '预测',
      list: [
        {
          label: '购彩计划',
          value: 'GouTsaiJiHua',
          link(lotteryCode) {
            return `/buyplan/${lotteryCode}`
          }
        },
        {
          label: '杀号计划',
          value: 'ShaHaoJiHua',
          link(lotteryCode) {
            return `/shjh/${lotteryCode}`
          }
        }
      ]
    }
  ],
  ssc: [
    {
      value: 'tab_zongHe',
      label: '综合',
      list: [
        {
          label: '即时开奖',
          value: 'JiShihKaiJiang',
          subList: [
            {
              label: '今日双面/号码统计',
              value: 'JinRiShuangMianHaoMaTongJi'

            },
            {
              label: '今日长龙统计',
              value: 'JinRiChangLongTongJi'

            },
            {
              label: '号码助手',
              value: 'HaoMaJhuShou'

            },
            {
              label: '历史开奖',
              value: 'LiShihKaiJiang'

            }
          ],
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JiShihKaiJiang`
          }
        },
        {
          label: '今日号码统计',
          value: 'JinRiHaoMaTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JinRiHaoMaTongJi`
          }
        },
        {
          label: '冷热分析',
          value: 'LengReFenXi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LengReFenXi`
          }
        },
        {
          label: '每日长龙统计',
          value: 'MeiRihChangLongTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=MeiRihChangLongTongJi`
          }
        },
        {
          label: '单双大小历史',
          value: 'DanShuangDaxiaoLiShi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DanShuangDaxiaoLiShi`
          }
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      list: [
        {
          label: '路珠分析',
          value: 'LuJhuFenSi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LuJhuFenSi`
          }
        },
        {
          label: '号码路珠',
          value: 'HaoMaLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HaoMaLuJhu`
          }
        },
        {
          label: '单双大小路珠',
          value: 'DanShuangDaXiaoLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DanShuangDaXiaoLuJhu`
          }
        },
        {
          label: '总和路珠',
          value: 'ZongHeLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=ZongHeLuJhu`
          }
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      list: [
        {
          label: '定位走势',
          value: 'DingWeiZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DingWeiZouShih`
          }
        },
        {
          label: '基本走势',
          value: 'JiBenZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JiBenZouShih`
          }
        },
        {
          label: '龙虎走势',
          value: 'LongHuZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LongHuZouShih`
          }
        },
        {
          label: '形态走势',
          value: 'XingTaiZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=XingTaiZouShih`
          }
        },
        {
          label: '定位横版走势',
          value: 'DingWeiHengBanZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DingWeiHengBanZouShih`
          }
        }
      ]
    },
    {
      value: 'tab_yutse',
      label: '预测',
      list: [
        {
          label: '专家推荐',
          value: 'JhuanJiaTueiJian',
          link(lotteryCode) {
            return `/expert/${lotteryCode}`
          }
        },
        {
          label: '购彩计划',
          value: 'GouTsaiJiHua',
          link(lotteryCode) {
            return `/buyplan/${lotteryCode}`
          }
        },
        {
          label: '杀号计划',
          value: 'ShaHaoJiHua',
          link(lotteryCode) {
            return `/shjh/${lotteryCode}`
          }
        }
      ]
    }
  ],
  xy28: [
    {
      value: 'tab_zongHe',
      label: '综合',
      list: [
        {
          label: '即时开奖',
          value: 'JiShihKaiJiang',
          subList: [
            {
              label: '历史开奖',
              value: 'LiShihKaiJiang'

            }
          ],
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JiShihKaiJiang`
          }
        },
        {
          label: '每日长龙统计',
          value: 'MeiRihChangLongTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=MeiRihChangLongTongJi`
          }
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      list: [
        {
          label: '总和路珠',
          value: 'ZongHeLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=ZongHeLuJhu`
          }
        },
        {
          label: '波色路珠',
          value: 'PoSeLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=PoSeLuJhu`
          }
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      list: [
        {
          label: '和值横版走势',
          value: 'HeJhihHengBanZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HeJhihHengBanZouShih`
          }
        }
      ]
    },
    {
      value: 'tab_yutse',
      label: '预测',
      list: [
        {
          label: '购彩计划',
          value: 'GouTsaiJiHua',
          link(lotteryCode) {
            return `/buyplan/${lotteryCode}`
          }
        }
      ]
    }
  ],
  kl8: [
    {
      value: 'tab_zongHe',
      label: '综合',
      list: [
        {
          label: '即时开奖',
          value: 'JiShihKaiJiang',
          subList: [
            {
              label: '历史开奖',
              value: 'LiShihKaiJiang'
            }
          ],
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JiShihKaiJiang`
          }
        },
        {
          label: '每日长龙统计',
          value: 'MeiRihChangLongTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=MeiRihChangLongTongJi`
          }
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      list: [
        {
          label: '路珠分析',
          value: 'LuJhuFenSi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LuJhuFenSi`
          }
        }
      ]
    }
  ],
  kl10: [
    {
      value: 'tab_zongHe',
      label: '综合',
      list: [
        {
          label: '即时开奖',
          value: 'JiShihKaiJiang',
          subList: [
            {
              label: '今日双面统计',
              value: 'JinRiShuangMianTongJi'

            },
            {
              label: '今日长龙统计',
              value: 'JinRiChangLongTongJi'

            },
            {
              label: '号码助手',
              value: 'HaoMaJhuShou'

            },
            {
              label: '历史开奖',
              value: 'LiShihKaiJiang'

            }
          ],
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JiShihKaiJiang`
          }
        },
        {
          label: '今日号码统计',
          value: 'JinRiHaoMaTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JinRiHaoMaTongJi`
          }
        },
        {
          label: '每日长龙统计',
          value: 'MeiRihChangLongTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=MeiRihChangLongTongJi`
          }
        },
        {
          label: '两面统计',
          value: 'LiangMianTongJi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LiangMianTongJi`
          }
        },
        {
          label: '单双大小历史',
          value: 'DanShuangDaxiaoLiShi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DanShuangDaxiaoLiShi`
          }
        }
      ]
    },
    {
      value: 'tab_roadball',
      label: '路珠',
      list: [
        {
          label: '路珠分析',
          value: 'LuJhuFenSi',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LuJhuFenSi`
          }
        },
        {
          label: '单双大小路珠',
          value: 'DanShuangDaXiaoLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DanShuangDaXiaoLuJhu`
          }
        },
        {
          label: '龙虎路珠',
          value: 'LongHuLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=LongHuLuJhu`
          }
        },
        {
          label: '尾数大小路珠',
          value: 'WeiShuDaXiaoLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=WeiShuDaXiaoLuJhu`
          }
        },
        {
          label: '合数单双路珠',
          value: 'HeShuDanShuangLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HeShuDanShuangLuJhu`
          }
        },
        {
          label: '中发白路珠',
          value: 'JhongFaBaiLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JhongFaBaiLuJhu`
          }
        },
        {
          label: '东南西北路珠',
          value: 'DongNanSiBeiLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DongNanSiBeiLuJhu`
          }
        },
        {
          label: '总和路珠',
          value: 'ZongHeLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=ZongHeLuJhu`
          }
        },
        {
          label: '号码路珠',
          value: 'HaoMaLuJhu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HaoMaLuJhu`
          }
        }
      ]
    },
    {
      value: 'tab_zoushi',
      label: '走势',
      list: [
        {
          label: '号码分布',
          value: 'HaoMaFenBu',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=HaoMaFenBu`
          }
        },
        {
          label: '大小走势',
          value: 'DaXiaoZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DaXiaoZouShih`
          }
        },
        {
          label: '奇偶走势',
          value: 'JiOuZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JiOuZouShih`
          }
        },
        {
          label: '定位横版走势',
          value: 'DingWeiHengBanZouShih',
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=DingWeiHengBanZouShih`
          }
        }
      ]
    }
  ],
  others: [
    {
      value: 'tab_zongHe',
      label: '综合',
      list: [
        {
          label: '即时开奖',
          value: 'JiShihKaiJiang',
          subList: [
            {
              label: '历史开奖',
              value: 'LiShihKaiJiang'
            }
          ],
          link(lotteryCode) {
            return `/lottery/trend/${lotteryCode}?trendType=JiShihKaiJiang`
          }
        }
      ]
    }
  ]
}

export {
  trendTabbarMapping,
  webTrendTabbarMapping
}
